import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useOffersQuery = createQueryHook(OffersApiClient.getOffers, {
  queryKey: ['offers'],
  select: (data) => {
    data.offers = data.offers.map((offer) => ({ ...offer, name: decodeHtmlEntities(offer.name) }))

    return data
  },
})
